// This file is automatically generated. Do not edit it directly.
// Hand-edited anyway: the session is shared with fernduft.com through
// createSharedAuthStorage. If Lovable regenerates this file, restore
// `storage` and `storageKey` below or the two sites stop sharing a sign-in.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { createSharedAuthStorage, SHARED_AUTH_STORAGE_KEY } from '@/lib/sharedAuthStorage';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

/** The shared session store; the remembered-accounts list lives beside the session in it. */
export const authStorage = createSharedAuthStorage(SUPABASE_URL);

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: authStorage,
    storageKey: SHARED_AUTH_STORAGE_KEY,
    persistSession: true,
    autoRefreshToken: true,
  }
});